// CN
import { BaiduMap, Marker as CMarker } from "react-baidu-maps";

// Not CN
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker
} from "react-google-maps";

import React from "react";
import preLoading from "Assets/Images/preLoading.png";
import top from "Assets/Images/top.png";
import contentIntroduction1 from "Assets/Images/contentIntroduction1.png";
import contentIntroduction2 from "Assets/Images/contentIntroduction2.png";
import contentIntroduction3 from "Assets/Images/contentIntroduction3.png";

import slide01 from "Assets/Images/slides/intSlide01.jpg";
import slide02 from "Assets/Images/slides/intSlide02.jpg";
import slide03 from "Assets/Images/slides/intSlide03.jpg";
import slide04 from "Assets/Images/slides/intSlide04.jpg";
import slide05 from "Assets/Images/slides/intSlide05.jpg";
import slide06 from "Assets/Images/slides/intSlide06.jpg";
import slide07 from "Assets/Images/slides/intSlide07.jpg";
import slide08 from "Assets/Images/slides/intSlide08.jpg";

import Swiper from "react-id-swiper";
import { Navigation } from "swiper/dist/js/swiper.esm";

import Lightbox from "lightbox-react";
import "lightbox-react/style.css";

const isCN = true;

function Map() {
  return (
    <GoogleMap defaultZoom={15} defaultCenter={defaultCenter}>
      <Marker position={defaultCenter} />
    </GoogleMap>
  );
}
const WrappedMap = withScriptjs(withGoogleMap(Map));

const images = [
  { id: 0, src: slide01 },
  { id: 1, src: slide02 },
  { id: 2, src: slide03 },
  { id: 3, src: slide04 },
  { id: 4, src: slide05 },
  { id: 5, src: slide06 },
  { id: 6, src: slide07 },
  { id: 7, src: slide08 }
];

const defaultCenter = { lng: 127.01444, lat: 37.491579 };
const defaultZoom = 16;
const enableDragging = true;

export default class extends React.Component {
  state = {
    loading: true,
    photoIndex: 0,
    isOpen: false
  };

  componentDidMount() {
    this.setState({ loading: false });
  }

  _goToTop() {
    window.scrollTo(0, 0);
  }

  _openLightbox(idx) {
    this.setState({ photoIndex: idx });
    this.setState({ isOpen: true });
  }

  render() {
    const { loading, photoIndex, isOpen } = this.state;
    const params = {
      modules: [Navigation],
      slidesPerView: 6,
      spaceBetween: 2,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      noSwiping: true
    };
    return (
      <div className="contents introduction">
        <img
          src={loading ? preLoading : contentIntroduction1}
          alt="preLoading"
          className="contentMain"
        />
        <div className="contentMain intro-slide">
          <Swiper {...params}>
            {images.map(image => (
              <div key={image.id}>
                <img
                  src={image.src}
                  alt={"image" + image.id}
                  id={"image" + image.id}
                  // onClick={() => this._openLightbox(image.id)}
                  onClick={() => this._openLightbox(image.id)}
                />
              </div>
            ))}
          </Swiper>
        </div>
        <img
          src={contentIntroduction2}
          alt="contentIntroduction2"
          className="contentMain"
        />
        <div>
          {isOpen && (
            <Lightbox
              mainSrc={images[photoIndex].src}
              nextSrc={images[(photoIndex + 1) % images.length].src}
              prevSrc={
                images[(photoIndex + images.length - 1) % images.length].src
              }
              onCloseRequest={() => this.setState({ isOpen: false })}
              onMovePrevRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + images.length - 1) % images.length
                })
              }
              onMoveNextRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + 1) % images.length
                })
              }
            />
          )}
        </div>
        {isCN ? (
          <div className="maps">
            <BaiduMap
              mapUrl={`http://api.map.baidu.com/api?v=2.0&ak=pdWpMi9dG6TvzAXOYC7E40KP13hnDFEj`}
              loadingElement={<div>Loading.....</div>}
              mapContainer={<div style={{ height: "100%" }} />}
              defaultCenter={defaultCenter}
              defaultZoom={defaultZoom}
              enableScrollWheelZoom
              enableDragging={enableDragging}
            >
              <CMarker position={{ lng: 127.014446, lat: 37.491576 }} />
            </BaiduMap>
          </div>
        ) : (
          <div className="maps">
            <WrappedMap
              googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyDVeXGJqVyFbENKDy_IecRtNUqqbk7-224`}
              loadingElement={
                <div
                  style={{ height: "100%", width: "42vw", margin: "auto" }}
                />
              }
              containerElement={
                <div
                  style={{ height: "100%", width: "42vw", margin: "auto" }}
                />
              }
              mapElement={<div style={{ height: "100%" }} />}
            />
          </div>
        )}
        <img
          src={contentIntroduction3}
          alt="contentIntroduction3"
          className="contentMain"
        />
        <img
          src={top}
          alt="top"
          className={loading ? "invisible contentTop" : "contentTop"}
          onClick={this._goToTop}
        />
      </div>
    );
  }
}
